import { createUUIDFactory } from './uuid';

export const clientUUID = createUUIDFactory();
